module.exports = __webpack_public_path__ + "img/57.50ea73e9.jpg";